export default __webpack_public_path__ + "static/media/discounts-bogo-on-sides-image.0ae1a1ac.svg";